var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{class:_vm.status == 'terminated' || _vm.status == 'done'
        ? 'red darken-2 white--text my-1 mr-1'
        : _vm.status == 'in-termination'
        ? 'amber darken-3 white--text my-1 mr-1'
        : 'green darken-3 white--text my-1 mr-1',attrs:{"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.$t(_vm.status))+" ")]),(_vm.blocked)?_c('v-chip',{staticClass:"deep-orange grey--text text--lighten-2 my-1 mr-1",attrs:{"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.$t("blocked"))+" "),_c('v-icon',{staticClass:"grey--text text--lighten-2",attrs:{"small":"","right":""}},[_vm._v(" mdi-power-plug-off ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }